<template>
  <div></div>
</template>

<script>
import { authService } from "../services/auth.service";

export default {
  name: "AuthGuard",
  created() {
    this.checkAuthentication();
  },
  methods: {
    checkAuthentication() {
      authService.isAuthenticated().then(
        res => {
          // console.log("isAuth", res);
        },
        err => {
          console.error("err", err);
          window.location.href = process.env.VUE_APP_SSO_LOGIN_URL;
        }
      );
    }
  }
};
</script>

<style scoped></style>
